import type { NotificationType } from '@parlay-picker/shared/notification';
import {
  AlertTriangle,
  Bell,
  DollarSign,
  Flame,
  Link2,
  TrendingDown,
  TrendingUp,
  Trophy,
  Unlink,
  Users,
  Zap,
} from 'lucide-react';
import type { ReactElement } from 'react';

export function getTypeIcon(type: NotificationType, className: string): ReactElement {
  switch (type) {
    case 'bet_won':
    case 'parlay_leg_hit':
      return <Trophy className={className} />;
    case 'bet_lost':
    case 'parlay_leg_lost':
    case 'leg_busted':
      return <TrendingDown className={className} />;
    case 'bet_pushed':
    case 'bet_voided':
      return <Zap className={className} />;
    case 'line_crossed':
    case 'progress_milestone':
      return <TrendingUp className={className} />;
    case 'game_starting':
    case 'halftime_summary':
    case 'streak_alert':
      return <Flame className={className} />;
    case 'followed_user_bet':
    case 'followed_user_settled':
    case 'parlay_shared_with_you':
    case 'parlay_shared_by_you':
    case 'new_follower':
      return <Users className={className} />;
    case 'subscription_upgraded':
    case 'subscription_renewed':
    case 'welcome':
    case 'creator_eligible':
    case 'creator_payout_sent':
      return <DollarSign className={className} />;
    case 'subscription_downgraded':
    case 'subscription_cancelled':
    case 'subscription_expiring':
      return <DollarSign className={className} />;
    case 'subscription_payment_failed':
    case 'creator_connect_reminder':
    case 'creator_payout_failed':
    case 'quota_warning':
      return <AlertTriangle className={className} />;
    case 'line_movement_alert':
    case 'slate_line_movement_alert':
      return <TrendingUp className={className} />;
    case 'sharp_signal_alert':
    case 'slate_sharp_signal_alert':
      return <Zap className={className} />;
    case 'injury_alert':
    case 'slate_injury_alert':
      return <AlertTriangle className={className} />;
    case 'account_linked':
      return <Link2 className={className} />;
    case 'account_unlinked':
      return <Unlink className={className} />;
    default:
      return <Bell className={className} />;
  }
}
